<template>
  <v-col cols="12">
    <v-row no-gutters class="ml-2">
      <v-col>
        <v-checkbox
          v-model="internalValue"
          hide-details="auto"
          :true-value="true"
          :false-value="false"
          style="margin-top: 0px !important"
          @change="handleChange"
          :disabled="disabled"
        >
          <template v-slot:label>
            <span
              :style="internalValue === true && 'text-decoration: underline;'"
            >
              {{ $t("dialog.yes") }}
            </span>
          </template>
        </v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          v-model="internalValue"
          hide-details="auto"
          :true-value="false"
          :false-value="true"
          style="margin-top: 0px !important"
          @change="handleChange"
          :disabled="disabled"
        >
          <template v-slot:label>
            <span
              :style="internalValue === false && 'text-decoration: underline;'"
            >
              {{ $t("dialog.no") }}
            </span>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, String],
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      internalValue:
        this.value == null
          ? null
          : this.value === "true" || this.value === true,
    };
  },

  methods: {
    handleChange(val) {
      this.$emit("update:value", val);
    },
  },
};
</script>
